import React from 'react';
import styled from 'styled-components';
import { getTranslatedString } from 'helpers/i18n';
import Col from 'components/ui/Col';
import CheckboxNormal from 'components/ui/CheckboxNormal';
import Spacer from 'components/ui/Spacer';
import Row from 'components/ui/Row';

const StyledCheckbox = styled(CheckboxNormal)`
  display: flex;
  align-items: center;
  height: 100%;
`;

const NotifyResidentsInput = ({ values, setFieldValue }) => {
  const handleChange = () => {
    setFieldValue('notify_residents', !values.notify_residents);
  };

  return (
    <Spacer mb={1}>
      <Row gutter={16}>
        <Col span={24}>
          <StyledCheckbox
            name="notify_residents"
            checked={values.notify_residents}
            onChange={handleChange}
          >
            {getTranslatedString('landlordPortal.events.notifyResidents')}
          </StyledCheckbox>
        </Col>
      </Row>
    </Spacer>
  );
};

export default NotifyResidentsInput;
